module.exports = __webpack_public_path__ + "img/explorers.992e9832.webp";